import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from '../../TestimonialTile.module.scss';
const TestimonialCaption = ({
  name,
  caption,
  instagram,
  productName
}) => {
  if (!caption && !instagram && !name && !productName) {
    return false;
  }
  const Component = instagram !== null && instagram !== void 0 && instagram.href ? 'a' : 'div';
  return /*#__PURE__*/React.createElement("figcaption", {
    className: styles.rootFigcaption
  }, name && /*#__PURE__*/React.createElement("cite", {
    className: styles.rootFigcaptionName
  }, name), (instagram === null || instagram === void 0 ? void 0 : instagram.label) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootFigcaptionWrapper
  }, !caption && /*#__PURE__*/React.createElement(Icon, {
    name: "instagram",
    size: {
      width: 22,
      height: 22
    },
    classname: styles.rootFigcaptionIcon
  }), (caption || (instagram === null || instagram === void 0 ? void 0 : instagram.label) && (instagram === null || instagram === void 0 ? void 0 : instagram.href)) && /*#__PURE__*/React.createElement(Component, {
    href: (instagram === null || instagram === void 0 ? void 0 : instagram.href) || null,
    rel: instagram !== null && instagram !== void 0 && instagram.href ? 'noopener noreferrer nofollow' : null,
    target: instagram !== null && instagram !== void 0 && instagram.href ? 'blank' : null,
    className: styles.rootFigcaptionText
  }, caption || (instagram === null || instagram === void 0 ? void 0 : instagram.label))), productName && /*#__PURE__*/React.createElement("p", {
    className: styles.rootProductName
  }, productName));
};
export default TestimonialCaption;